import { Button } from '@cluey/cluey-components';
import classNames from 'classnames';
import { forwardRef, useImperativeHandle, useState } from 'react';

import type { Enrolment } from '../../../../api/types/enrolment';
import type { CancelReason } from '../../../../types/hubInterfaces';
import { CancelRating } from './CancelRating';
import { CancelReasons } from './CancelReasons';

export type State = {
  selectedDate: string;
  rating: number;
  selectedReasons: Array<CancelReason>;
  message: string;
  other: {
    message: string;
  };
};

export interface Props {
  onSubmitCancelRequest(): void;
  cancelSelection: State;
  setCancelSelection: React.Dispatch<React.SetStateAction<State>>;
  selectedEnrolment: Enrolment;
}

const CancellationSteps = forwardRef(
  ({ onSubmitCancelRequest, cancelSelection, setCancelSelection, selectedEnrolment }: Props, ref) => {
    const [stepIndex, setStepIndex] = useState(0);
    useImperativeHandle(ref, () => {
      return {
        getStepIndex: () => stepIndex,
        goBack: () => setStepIndex(stepIndex - 1),
      };
    }, [stepIndex]);

    const steps = [
      <CancelRating
        rating={cancelSelection.rating}
        setCancelSelection={setCancelSelection}
        labelClassName="merriweather"
      />,
      <CancelReasons
        onSubmitCancelRequest={onSubmitCancelRequest}
        cancelSelection={cancelSelection}
        setCancelSelection={setCancelSelection}
        selectedEnrolment={selectedEnrolment}
      />,
    ];
    const onNextClick = () => setStepIndex(stepIndex + 1);

    const showNext = stepIndex + 1 < steps.length;

    return (
      <div className={classNames('mt-5', showNext && 'mb-8')}>
        <div className="flex justify-center">{steps[stepIndex]}</div>
        {showNext && (
          <div className="text-center">
            <Button
              disabled={cancelSelection.rating === 0 || !!!cancelSelection.selectedDate}
              appearance="solid"
              onClick={onNextClick}
              className="ctaButton !mt-3 !px-10 !py-3 text-base capitalize"
            >
              Next
            </Button>
          </div>
        )}
      </div>
    );
  }
);

export default CancellationSteps;
